export enum MessageType {
    BLOCKING = 'BLOCKING',
    CONFIRM = 'CONFIRM'
};
